/* Mawlaii Product page — interactivity (progressive enhancement) */
(function () {
  'use strict';

  // ----- Accordion toggle -----
  document.querySelectorAll('.mp__acc-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.mp__acc-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      item.classList.toggle('is-closed', isOpen);
    });
  });

  // ----- Variant chip toggle + hidden select sync -----
  var form = document.getElementById('ProductForm');
  var hiddenSelect = document.getElementById('VariantSelect');

  function getSelectedOptions() {
    var groups = document.querySelectorAll('.mp__variant-chips');
    var selected = [];
    groups.forEach(function (group) {
      var active = group.querySelector('.mp__variant-chip.is-selected');
      if (active) selected.push(active.getAttribute('data-value'));
    });
    return selected;
  }

  function syncVariant() {
    if (!hiddenSelect) return;
    var selected = getSelectedOptions();
    var matchKey = selected.join('|');
    var options = hiddenSelect.querySelectorAll('option');
    options.forEach(function (opt) {
      if (opt.getAttribute('data-options') === matchKey) {
        hiddenSelect.value = opt.value;
        var idInput = form && form.querySelector('input[name="id"]');
        if (idInput) idInput.value = opt.value;
      }
    });
  }

  document.querySelectorAll('.mp__variant-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('.mp__variant-chip');
      if (!chip || chip.disabled) return;
      group.querySelectorAll('.mp__variant-chip').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      chip.classList.add('is-selected');

      // Update the "selected value" label small text
      var label = group.parentElement && group.parentElement.querySelector('[data-mp-selected-value]');
      if (label) label.textContent = chip.getAttribute('data-value');

      syncVariant();

      var optName = group.getAttribute('data-mp-option-name') || '';
      if (optName === 'color' || optName === 'colour') {
        mpFilterGallery((chip.getAttribute('data-value') || '').toLowerCase());
      }
    });
  });

  // ----- Thumbnail overflow — show max 8 tiles, "+N" reveals the rest -----
  var MP_THUMB_MAX = 8;
  function mpApplyThumbOverflow() {
    var wrap = document.querySelector('.mp__gallery-thumbs');
    if (!wrap) return;
    var more = wrap.querySelector('.mp__gallery-more');
    var visible = Array.prototype.filter.call(
      wrap.querySelectorAll('.mp__gallery-thumb'),
      function (t) { return !t.classList.contains('is-hidden'); }
    );
    visible.forEach(function (t) { t.classList.remove('is-overflow-hidden'); });
    if (visible.length <= MP_THUMB_MAX) {
      if (more) more.style.display = 'none';
      return;
    }
    var shown = MP_THUMB_MAX - 1;
    visible.slice(shown).forEach(function (t) { t.classList.add('is-overflow-hidden'); });
    if (!more) {
      more = document.createElement('button');
      more.type = 'button';
      more.className = 'mp__gallery-more';
      more.setAttribute('aria-label', 'Show all images');
      more.addEventListener('click', function () {
        mpOpenLightbox(MP_THUMB_MAX - 1);
      });
      wrap.appendChild(more);
    }
    more.textContent = '+' + (visible.length - shown);
    more.style.display = '';
  }
  mpApplyThumbOverflow();

  // ----- Variant-aware gallery filter (colour) -----
  function mpFilterGallery(colorDown) {
    var slides = document.querySelectorAll('.mp__gallery-slide');
    var thumbs = document.querySelectorAll('.mp__gallery-thumb');
    var firstVisible = null, firstExact = null;
    slides.forEach(function (slide) {
      var c = slide.getAttribute('data-mp-color') || '';
      var show = !c || c === colorDown;
      slide.classList.toggle('is-hidden', !show);
      if (!show) {
        var vid = slide.querySelector('video');
        if (vid && !vid.paused) vid.pause();
        slide.classList.remove('is-active');
      } else {
        var idx = slide.getAttribute('data-mp-slide');
        if (firstVisible === null) firstVisible = idx;
        if (c === colorDown && firstExact === null) firstExact = idx;
      }
    });
    thumbs.forEach(function (thumb) {
      var c = thumb.getAttribute('data-mp-color') || '';
      var show = !c || c === colorDown;
      thumb.classList.toggle('is-hidden', !show);
    });
    // Always promote the selected colour's own photo (if it has one), else the first visible.
    var target = firstExact !== null ? firstExact : firstVisible;
    if (target !== null) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-mp-slide') === target); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-mp-thumb') === target); });
    }
    mpApplyThumbOverflow();
  }

  // ----- Quantity stepper -----
  document.querySelectorAll('.mp__qty').forEach(function (qty) {
    var input = qty.querySelector('.mp__qty-input');
    var minus = qty.querySelector('[data-mp-qty-minus]');
    var plus = qty.querySelector('[data-mp-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ----- Thumbnail gallery (image + video slides) -----
  var mpSlides = document.querySelectorAll('.mp__gallery-slide');
  document.querySelectorAll('.mp__gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = thumb.getAttribute('data-mp-thumb');
      document.querySelectorAll('.mp__gallery-thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      mpSlides.forEach(function (slide) {
        var on = slide.getAttribute('data-mp-slide') === idx;
        slide.classList.toggle('is-active', on);
        if (!on) {
          var vid = slide.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
      });
    });
  });

  // ----- Lightbox — click the main image to browse the full set -----
  var mpLb = null, mpLbIndex = 0, mpLbTab = 'images';

  function mpVisibleSlides() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.mp__gallery-slide'),
      function (s) { return !s.classList.contains('is-hidden'); }
    );
  }

  function mpLbIsVideoSlide(s) {
    return !!(s.querySelector('video') || s.querySelector('.mp__gallery-embed'));
  }

  function mpLbSet() {
    var wantVideo = mpLbTab === 'videos';
    return mpVisibleSlides().filter(function (s) { return mpLbIsVideoSlide(s) === wantVideo; });
  }

  function mpBuildLightbox() {
    if (mpLb) return mpLb;
    mpLb = document.createElement('div');
    mpLb.className = 'mp__lb';
    mpLb.innerHTML =
      '<div class="mp__lb-card">' +
        '<div class="mp__lb-bar">' +
          '<div class="mp__lb-tabs">' +
            '<button type="button" class="mp__lb-tab" data-mp-tab="videos">Videos</button>' +
            '<button type="button" class="mp__lb-tab" data-mp-tab="images">Images</button>' +
          '</div>' +
          '<div class="mp__lb-bar-right">' +
            '<span class="mp__lb-count"></span>' +
            '<button type="button" class="mp__lb-close" aria-label="Close">&times;</button>' +
          '</div>' +
        '</div>' +
        '<div class="mp__lb-body">' +
          '<div class="mp__lb-stage">' +
            '<button type="button" class="mp__lb-nav mp__lb-prev" aria-label="Previous">&#8249;</button>' +
            '<div class="mp__lb-media"></div>' +
            '<button type="button" class="mp__lb-nav mp__lb-next" aria-label="Next">&#8250;</button>' +
          '</div>' +
          '<div class="mp__lb-rail"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(mpLb);
    mpLb.addEventListener('click', function (e) { if (e.target === mpLb) mpCloseLightbox(); });
    mpLb.querySelector('.mp__lb-close').addEventListener('click', mpCloseLightbox);
    mpLb.querySelector('.mp__lb-prev').addEventListener('click', function () { mpLbShow(mpLbIndex - 1); });
    mpLb.querySelector('.mp__lb-next').addEventListener('click', function () { mpLbShow(mpLbIndex + 1); });
    mpLb.querySelectorAll('.mp__lb-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var t = tab.getAttribute('data-mp-tab');
        if (t === mpLbTab) return;
        mpLbTab = t;
        mpLbBuildRail();
        mpLbShow(0);
      });
    });
    var startX = null;
    mpLb.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
    mpLb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) mpLbShow(mpLbIndex + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
    return mpLb;
  }

  function mpLbBuildRail() {
    var rail = mpLb.querySelector('.mp__lb-rail');
    rail.innerHTML = '';
    mpLbSet().forEach(function (slide, i) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'mp__lb-rail-item';
      item.setAttribute('aria-label', 'View item ' + (i + 1));
      var idx = slide.getAttribute('data-mp-slide');
      var pageThumb = document.querySelector('.mp__gallery-thumb[data-mp-thumb="' + idx + '"] img');
      var img = slide.querySelector('img');
      var vid = slide.querySelector('video');
      var src = null;
      if (pageThumb) {
        src = pageThumb.cloneNode(true);
      } else if (img) {
        src = img.cloneNode(true);
        src.removeAttribute('sizes');
      } else if (vid && vid.getAttribute('poster')) {
        src = document.createElement('img');
        src.src = vid.getAttribute('poster');
        src.alt = '';
      }
      if (src) item.appendChild(src);
      if (mpLbIsVideoSlide(slide)) {
        var play = document.createElement('span');
        play.className = 'mp__lb-rail-play';
        item.appendChild(play);
      }
      item.addEventListener('click', function () { mpLbShow(i); });
      rail.appendChild(item);
    });
    var hasVideos = mpVisibleSlides().some(mpLbIsVideoSlide);
    mpLb.querySelector('.mp__lb-tabs').style.display = hasVideos ? '' : 'none';
    mpLb.querySelectorAll('.mp__lb-tab').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-mp-tab') === mpLbTab);
    });
  }

  function mpLbShow(idx) {
    var set = mpLbSet();
    if (!set.length) return;
    mpLbIndex = (idx + set.length) % set.length;
    var slide = set[mpLbIndex];
    var media = mpLb.querySelector('.mp__lb-media');
    media.innerHTML = '';
    var vid = slide.querySelector('video');
    if (vid) {
      var v = vid.cloneNode(true);
      v.classList.add('mp__lb-img');
      v.controls = true;
      media.appendChild(v);
    } else {
      var img = slide.querySelector('img');
      if (img) {
        var i2 = img.cloneNode(true);
        i2.className = 'mp__lb-img';
        i2.removeAttribute('loading');
        i2.sizes = '70vw';
        media.appendChild(i2);
      }
    }
    mpLb.querySelector('.mp__lb-count').textContent = (mpLbIndex + 1) + ' / ' + set.length;
    mpLb.querySelectorAll('.mp__lb-rail-item').forEach(function (it, n) {
      it.classList.toggle('is-active', n === mpLbIndex);
    });
  }

  function mpOpenLightbox(globalIdx) {
    mpBuildLightbox();
    var all = mpVisibleSlides();
    if (!all.length) return;
    var slide = all[Math.max(0, Math.min(globalIdx, all.length - 1))];
    mpLbTab = mpLbIsVideoSlide(slide) ? 'videos' : 'images';
    mpLbBuildRail();
    var within = mpLbSet().indexOf(slide);
    mpLbShow(within > -1 ? within : 0);
    mpLb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function mpCloseLightbox() {
    if (!mpLb) return;
    mpLb.classList.remove('is-open');
    document.body.style.overflow = '';
    var v = mpLb.querySelector('.mp__lb-media video');
    if (v && !v.paused) v.pause();
  }

  document.addEventListener('keydown', function (e) {
    if (!mpLb || !mpLb.classList.contains('is-open')) return;
    if (e.key === 'Escape') mpCloseLightbox();
    if (e.key === 'ArrowLeft') mpLbShow(mpLbIndex - 1);
    if (e.key === 'ArrowRight') mpLbShow(mpLbIndex + 1);
  });

  var mpMain = document.querySelector('.mp__gallery-main');
  if (mpMain) {
    mpMain.addEventListener('click', function (e) {
      var slide = e.target.closest('.mp__gallery-slide.is-active');
      if (!slide) return;
      if (mpLbIsVideoSlide(slide)) return;
      var idx = mpVisibleSlides().indexOf(slide);
      if (idx > -1) mpOpenLightbox(idx);
    });
  }

  // ----- Share button -----
  document.querySelectorAll('[data-mp-share]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var url = window.location.href;
      var title = document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          link.textContent = 'Link copied';
          setTimeout(function () { link.textContent = 'Share'; }, 2000);
        });
      }
    });
  });
})();
